"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autowired = void 0;
const IOC_1 = require("./IOC");
const Logger_1 = require("./Logger");
function Autowired(options) {
    if (typeof options === "string")
        throw new Error("Passing a string is deprecated, please pass an object instead!");
    // tslint:disable-next-line:ban-types
    return function decoratorFactory(target, decoratedPropertyName) {
        const dependencyName = options && options.name !== undefined ? options.name : decoratedPropertyName;
        if (!options || options.lazyLoading === undefined || options.lazyLoading === true) {
            target[decoratedPropertyName] = new Proxy(target, {
                get(t, key) {
                    const targetName = target.constructor.name + ".";
                    throw new Error(`The property ${targetName}${decoratedPropertyName} did not get initialized yet, call to ${key} will fail!`);
                }
            });
            IOC_1.IOC.onRegister(dependencyName, (injectable) => {
                target[decoratedPropertyName] = injectable;
            });
        }
        else {
            if (IOC_1.IOC.isRegistered(dependencyName))
                target[decoratedPropertyName] = IOC_1.IOC.get(dependencyName);
            else {
                Logger_1.Logger.debug("Autowired", `Could not autowire dependency '${dependencyName}'`, {
                    target,
                    decoratedPropertyName
                });
            }
        }
    };
}
exports.Autowired = Autowired;
